import type { AssignmentMap, TargetRef } from "../SettingsPayload";

import { parseTargetRef } from "./targetRef";

/**
 * ある枚を名指している生成担当の id を、`assignments` の並び順で返す。
 *
 * 名指しは 2 通りある。対象にその枚の `slide:` 参照を持つ場合と、その枚に載っている
 * 要素の `element:` 参照を持つ場合。後者を判定するには枚に属する creationId が要るため、
 * Office.js から読んだ一覧を呼び出し側が渡す。ストアは紙面の構造を知らない。
 */
export function selectAssignmentsForSlide(
    assignments: AssignmentMap,
    slideId: string,
    creationIds: readonly string[]
): string[] {
    const owned = new Set(creationIds);
    const out: string[] = [];
    for (const [id, assignment] of Object.entries(assignments)) {
        if (assignment.targets.some((ref) => coversSlide(ref, slideId, owned))) out.push(id);
    }
    return out;
}

function coversSlide(ref: TargetRef, slideId: string, owned: Set<string>): boolean {
    const parsed = parseTargetRef(ref);
    if (parsed.kind === "slide") return parsed.officeId === slideId;
    return owned.has(parsed.officeId);
}
